<template>
  <section id="users" class="content">
    <SkAnimation v-if="loading" :thumb="false" :tab="false"/>
    <div v-else class="listingCnt">
      <div class="listingItemCnt">
        <table>
          <tr>
            <th class="th1">Name</th>
            <th class="th2" colspan="2">{{type}}</th>
          </tr>
          <tr>
            <td colspan="3" class="tdHeader">
              <div class="listingHeader">
                <div class="lhItem" v-on:click="addCategory">
                  + Add new {{type}} category...
                </div>
                <div class="clear"></div>
              </div>
            </td>
          </tr>
          <tbody>
            <tr v-for="(item, index) in results" :key="index">
              <td class="td1">
                <div class="profile"></div>
                {{item.name}}
              </td>
              <td>
                <div class="classLink" v-if="item.content">
                  {{item.content.name}}
                </div>
                <div class="classLink" v-else-if="item.count > 0">
                  {{item.count}} {{type}}
                </div>
                <div class="noLink" v-else>None</div>
              </td>
              <td>
                <template v-if="item.id > 1">
                  <div class="action" v-on:click="itemOpenedId = item.id"></div>
                  <div :class="{actionOverlay: true, open: itemOpenedId == item.id}"
                    v-on:click="itemOpenedId = null"></div>
                  <div :class="{actionCnt: true, open: itemOpenedId == item.id}">
                    <div class="actionItem" v-on:click="editData(index, item)">
                      <img src="../assets/edit-black.png"> Edit Category
                    </div>
                    <div class="divider"></div>
                    <div class="actionItem actionRed" v-on:click="deleteData(index, item)">
                      <img src="../assets/delete.png"> Delete
                    </div>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <Confirmation ref="confirmDialog"/>
    <FormInputerShort ref="formInputer"/>
    <Snackbar ref="snackbar"/>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import SkAnimation from '@/components/SkAnimation.vue';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';

export default {
  name: 'home',
  components: {
    SkAnimation,
    Confirmation,
    Snackbar,
    FormInputerShort,
  },
  data() {
    return {
      loading: true,
      results: [],
      itemOpenedId: null,
      type: null,
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    deleteData(i, item) {
      this.itemOpenedId = null;
      const name = (item.name) ? item.name : 'Category';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: `Are you sure you want to delete this category?
          This operation can not be undone.`,
      }, (b) => {
        if (b) this.deleteNow(i, item);
      });
    },
    deleteNow(i, item) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: `To prevent from accidentally deleted category,
          you need to input your password.`,
        placeholder: 'Password',
        type: 'password',
        action: 'Delete Category',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.get(this.$config.uri(`${this.type}/category/delete/${item.id}`))
          .then((response) => {
            if (response.data.status !== 200) {
              // Display error
              return;
            }
            this.$refs.snackbar.open({ content: 'Category has been deleted.' });
          });
      });
    },
    addCategory() {
      this.$refs.formInputer.open({
        title: 'Add New Category',
        placeholder: 'Category Name',
        action: 'Save',
      }, (b, d) => {
        if (!b || !d || d === '') return;
        this.$http.post(this.$config.uri(`${this.type}/category`), {
          name: d,
        }).then((response) => {
          if (response.data.status === 200) {
            this.results.push(response.data.data);
          }
        });
      });
    },
    editData(i, item) {
      this.itemOpenedId = null;
      this.$refs.formInputer.open({
        title: 'Edit Category',
        placeholder: 'Category Name',
        value: item.name,
        action: 'Save',
      }, (b, d) => {
        if (!b || !d || d === '') return;
        this.results[i].name = d;
        this.$http.post(this.$config.uri(`${this.type}/category`), {
          id: item.id,
          name: d,
        }).then(() => {});
      });
    },
    getUsers() {
      this.$http.get(this.$config.uri(`${this.type}/categories/admin`)).then((response) => {
        this.loading = false;
        this.results = (response.data.status === 200) ? response.data.data : [];
      });
    },
  },
  mounted() {
    const { type } = this.$route.params;
    this.type = type;
    this.chTitle(`${type.substr(0, 1).toUpperCase()}${type.substr(1)} Category`);
    this.chCGB(false);
    this.getUsers();
  },
};
</script>


<style scoped lang="scss">
  .listingItemCnt{
    margin: 0 -30px;
  }
  .listingHeader{
    padding: 5px 20px;
    padding-left: 18px;
    .exportAll{
      float: right;
      background-color: #0057d8;
      font-size: 15px;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      transition: all .2s linear;
      color: #fff;
      cursor: pointer;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
    .exportAll:hover{
      background-color: #0067ff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    }
    .lhItem{
      font-size: 15px;
      float: left;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      opacity: .5;
      transition: all .2s linear;
      cursor: pointer;

      position: relative;
      padding-left: 46px;
      float: none;
      margin-right: 0;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
      .checkAll{
        width: 14px; height: 14px;
        border: #777 2px solid;
        border-radius: 4px;
        float: left;
        margin-right: 10px;
      }
    }
    .lhItem.rejectAll{
      opacity: 1;
      color: red;
    }
    .lhItem:before{
      content: "";
      position: absolute;
      left: 12px; top: 50%;
      margin-top: -9px;
      width: 18px; height: 18px;
      background-color: #ccc;
      border-radius: 5px;
    }
    .lhItem:hover{
      // background-color: #eee;
      opacity: 1;
    }
  }
  table{
    border-collapse: collapse;
    width: 100%;
    tr{
      th{
        text-align: left;
        font-weight: bold;
        color: #999;
        padding: 10px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        text-transform: uppercase;
        &.th1{
          padding-left: 64px;
        }
        &.th2{
          padding-left: 30px;
        }
      }
      td{
        padding: 14px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        position: relative;
        white-space: nowrap;
        &.td1{
          padding-left: 64px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 200px;
          font-weight: 600;
          p{
            color: #767676;
            margin: 0;
            font-weight: normal;
          }
        }
        &.tdHeader{
          padding: 0;
        }
        .profile{
          left: 30px;
          top: 50%;
          margin-top: -9px;
          position: absolute;
          width: 18px;
          height: 18px;
          // background-image: url(../assets/user.png);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 5px;
          border: #ccc 2px solid;
          box-sizing: border-box;
          opacity: 1;
          cursor: pointer;
          &:hover{
            border-color: #999;
          }
        }
        .noLink{
          padding-left: 10px;
        }
        .classLink{
          display: inline-block;
          padding: 2px 10px 4px;
          border-radius: 50px;
          &:hover{
            background-color: #0e5dd2;
            color: #fff;
            cursor: pointer;
          }
        }
        .action{
          position: absolute;
          right: 14px;
          top: 6px;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background-image: url(../assets/more.png);
          background-size: 18px auto;
          background-repeat: no-repeat;
          background-position: center;
          opacity: .4;
          cursor: pointer;
        }
        .action:hover{
          background-color: #ddd;
          opacity: .7;
        }
        .actionCnt{
          position: absolute;
          background: #fff;
          top: 100%;
          // border: 1px solid #ccc;
          box-shadow: 1px 1px 4px rgba(0,0,0,.2);
          border-radius: 10px;
          padding: 10px 0;
          white-space: nowrap;
          text-align: left;
          right: 14px;
          z-index: 4;
          margin-top: -5px;
          display: none;
          .divider{
            border-top: #eee 1px solid;
            padding-top: 4px;
            margin-top: 4px;
          }
          .actionItem{
            cursor: pointer;
            list-style: none;
            padding: 7px 42px;
            color: #444;
            font-size: 14px;
            min-width: 100px;
            img{
              height: 15px;
              margin: -4px 4px -2px -22px;
            }
          }
          .actionItem.actionRed{
            color: red;
          }
          .actionItem:hover{
            background-color: #eee;
          }
        }
        .actionCnt.open{
          display: block;
        }
        .actionOverlay{
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          display: none;
        }
        .actionOverlay.open{
          display: block;
        }
      }
    }
    tbody{
      tr:hover{
        background-color: #f5f5f5;
        background-color: #f0f4ff;
        // cursor: pointer;
      }
    }
  }
</style>
